var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6654 18.2148C16.6654 17.0519 16.6654 16.4704 16.5218 15.9972C16.1987 14.9319 15.365 14.0982 14.2997 13.775C13.8265 13.6315 13.245 13.6315 12.082 13.6315H7.91537C6.7524 13.6315 6.17091 13.6315 5.69775 13.775C4.63241 14.0982 3.79873 14.9319 3.47556 15.9972C3.33203 16.4704 3.33203 17.0519 3.33203 18.2148M13.7487 6.96484C13.7487 9.03591 12.0698 10.7148 9.9987 10.7148C7.92763 10.7148 6.2487 9.03591 6.2487 6.96484C6.2487 4.89378 7.92763 3.21484 9.9987 3.21484C12.0698 3.21484 13.7487 4.89378 13.7487 6.96484Z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberAvatar);
export default __webpack_public_path__ + "static/media/memberAvatar.912b58e8a7c25c497986610cf3727e60.svg";
export { ForwardRef as ReactComponent };